export default "__VITE_ASSET__CvH$LM_t__"